import React, { useContext, useEffect } from 'react';
import { Redirect, Route,useLocation, useHistory } from 'react-router-dom';
import { AdminContext } from '../../context/AdminContext';
import Cookies from 'js-cookie';

const PrivateRoute = ({ children, ...rest }) => {
  const { state } = useContext(AdminContext);
  const { userObject } = state;

  const location = useLocation();
  const history = useHistory();

  let email = undefined;


  if (localStorage.getItem('userObject')) {
    email = JSON.parse(localStorage.getItem('userObject')).email;

  }
  else{
    const params = new URLSearchParams(location.search);
    const classroomId = params.get("id");
   
    const userTeacher = params.get("user");

    const fromAcademia = params.get("from"); // ej: "prueba"
  

    if (classroomId) {
      localStorage.setItem("classroom", classroomId);
    }

    if (userTeacher) {
      localStorage.setItem("userTeacher", userTeacher);
    }

    if (fromAcademia) 
      localStorage.setItem('academiaDomain', fromAcademia);

  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        email !== undefined ? (
          children
        ) : (
            
          <Redirect
          to={{
            pathname: ['/', '/initial'].includes(location.pathname) ? '/initial' : JSON.parse(localStorage.getItem('userObject'))?.academiaId ? '/signinacademia' : '/signin',
            state: { from: location },
          }}
        />        
        )
      }
    />
  );
};

export default PrivateRoute;

